// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"61":"vsf-contact","87":"vsf-privacy-policy","231":"vsf-home","278":"vsf-project","664":"vsf-page-not-found","855":"vsf-contact-success"}[chunkId] + "." + {"61":"b0d155fb","87":"5de7e6db","231":"843b7ef4","278":"9d1a3f24","664":"a31c4fdb","855":"606c40ad"}[chunkId] + ".css";
};